import { render, staticRenderFns } from "./cardSales.vue?vue&type=template&id=3b88a431&"
import script from "./cardSales.vue?vue&type=script&lang=js&"
export * from "./cardSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports